import { render, staticRenderFns } from "./BillReceiveForm.vue?vue&type=template&id=2d4491c6"
import script from "./BillReceiveForm.vue?vue&type=script&lang=js"
export * from "./BillReceiveForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports